<!-- Pièces de la commande (objecttyp 3) puis de chaque BL (objecttyp 4) ; chaque section dépose sur SON objet.
     L'affichage et les gestes sont ceux du carrousel commun (doc : front.sales.quotation-panneau-lateral). -->
<div class="orderdocs">
  @if (orderId > 0) {
    <div class="docs-head">
      <span class="docs-count">{{ totalCount }} document{{ totalCount > 1 ? 's' : '' }}</span>
    </div>
    @if (loading) {
      <div class="docs-wait"><mat-spinner diameter="28"></mat-spinner><span>Chargement des documents…</span></div>
    } @else {
      @for (section of sections; track section.objecttyp + '-' + section.objectid) {
        <div class="doc-section" [class.dragging]="dragging === section" (dragover)="onDragOver(section, $event)" (dragleave)="onDragLeave()" (drop)="onDrop(section, $event)">
          <div class="section-head">
            <mat-icon class="section-icon">{{ section.kind === 'order' ? 'receipt_long' : 'local_shipping' }}</mat-icon>
            <!-- Le titre d'un BL est un bouton : il ouvre la modale des livraisons sur ce bon-là. -->
            @if (section.kind === 'delivery') {
              <button type="button" class="section-title link" (click)="onTitleClick(section)" matTooltip="Ouvrir le bon de livraison">{{ section.title }}</button>
            } @else {
              <span class="section-title">{{ section.title }}</span>
            }
            @if (section.note) {
              <span class="section-note">— {{ section.note }}</span>
            }
            <span class="spacer"></span>
            @if (canEdit) {
              <input type="file" hidden multiple #sectionInput (change)="onPickDocuments(section, $event)" />
              <button mat-stroked-button type="button" class="section-add" [disabled]="section.uploading" (click)="sectionInput.click()"
                [matTooltip]="section.kind === 'order' ? 'Joindre un ou plusieurs fichiers à la commande (ou les déposer ici)' : 'Joindre un ou plusieurs fichiers à ce bon de livraison (ou les déposer ici)'">
                <mat-icon>attach_file</mat-icon>{{ section.uploading ? 'Dépôt…' : 'Importer' }}
              </button>
            }
          </div>
          @if (section.docs.length) {
            <app-image-carousel [attachs]="section.docs" [canEdit]="canEdit"></app-image-carousel>
          } @else {
            <div class="section-none">
              @if (section.kind === 'order') {
                Aucun document sur la commande.
              } @else {
                Aucune pièce — le bon de livraison n'est pas encore signé.
              }
            </div>
          }
        </div>
      }
    }
  } @else {
    <div class="section-none">Enregistrez la commande pour pouvoir y joindre des documents.</div>
  }
</div>
